import {
  Activity,
  ArrowDownToLine,
  ArrowLeft,
  ArrowRight,
  Award,
  Backpack,
  BrickWall,
  Check,
  ChevronDown,
  ChevronRight,
  Coins,
  Compass,
  Crosshair,
  Drumstick,
  FlaskConical,
  Footprints,
  Gamepad2,
  Gem,
  Globe,
  Hammer,
  Hand,
  Heart,
  House,
  IdCard,
  Info,
  KeyRound,
  Layers,
  LayoutGrid,
  List,
  LocateFixed,
  LogOut,
  MapIcon,
  Minus,
  MessageSquare,
  Monitor,
  MousePointerClick,
  Move,
  Package,
  Pause,
  Pickaxe,
  Play,
  Plus,
  RotateCcw,
  Save,
  ScrollText,
  Settings,
  Shield,
  Sparkles,
  Split,
  Star,
  Sword,
  Swords,
  TriangleAlert,
  Trophy,
  User,
  Users,
  Volume2,
  Wind,
  X,
  Zap,
  type IconNode,
} from "@eldrun/web-ui/ui";
import type { KitIcon } from "./kit-model.ts";

/**
 * O desenho de cada ícone do kit (F113, ADR 0024): SVG do Lucide, do vocabulário único do
 * `@eldrun/web-ui/ui`, no lugar dos recortes PNG tingidos por máscara. O nome continua o do kit (quem
 * chama não muda); cada gesto tem um desenho só.
 */
export const KIT_ICON_NODES: Readonly<Record<KitIcon, IconNode>> = {
  "icone-jogar": Play,
  "icone-continuar": ArrowRight,
  "icone-multijogador": Users,
  "icone-opcoes": Settings,
  "icone-sair": LogOut,
  "icone-conta": User,
  "icone-novidades": Sparkles,
  "icone-chevron": ChevronRight,
  "icone-site": Globe,
  "icone-inicio": House,
  "icone-salvar": Save,
  "icone-tela": Monitor,
  "icone-som": Volume2,
  "icone-controle": Gamepad2,
  "icone-voltar": ArrowLeft,
  "icone-restaurar": RotateCcw,
  "icone-confirmar": Check,
  "icone-triangulo": ChevronDown,
  "icone-x": X,
  "hud-opcoes": Settings,
  "hud-mochila": Backpack,
  "hud-mapa": MapIcon,
  "hud-pausa": Pause,
  "hud-icone-opcoes": Settings,
  "hud-icone-mochila": Backpack,
  "hud-icone-mapa": MapIcon,
  "hud-icone-menu": Pause,
  "hud-interagir": Hand,
  "hud-alerta": TriangleAlert,
  "icone-inventario": Backpack,
  "icone-fabricacao": Hammer,
  "vital-vida": Heart,
  "vital-fome": Drumstick,
  "vital-folego": Wind,
  "aba-bencaos": Sparkles,
  "aba-habilidades": Zap,
  "categoria-todos": LayoutGrid,
  "categoria-ferramentas": Pickaxe,
  "categoria-armas": Sword,
  "categoria-armaduras": Shield,
  "categoria-consumiveis": FlaskConical,
  "categoria-materiais": Gem,
  "categoria-construcao": BrickWall,
  "icone-mapa": MapIcon,
  "mapa-bussola": Compass,
  "mapa-mais": Plus,
  "mapa-menos": Minus,
  "icone-centralizar": LocateFixed,
  "icone-legenda": List,
  "icone-detalhe": Info,
  "icone-ficha": IdCard,
  "icone-perfil": User,
  "icone-atributos": Activity,
  "icone-talentos": Star,
  "icone-biografia": ScrollText,
  "icone-nivel": Award,
  "icone-classe": Swords,
  "icone-defesa": Shield,
  "icone-velocidade": Footprints,
  "icone-mira": Crosshair,
  "icone-mover": Move,
  "icone-dividir": Split,
  "icone-usar": MousePointerClick,
  "icone-largar": ArrowDownToLine,
  "icone-pilha": Layers,
  "icone-moedas": Coins,
  "icone-itens": Package,
  "icone-seta": ArrowRight,
  "icone-codigo": KeyRound,
  "icone-feedback": MessageSquare,
  "icone-rankings": Trophy,
};
